<template>
  <section class="listed">
    <div class="blex w-full bg-black py-80 lg:pt-0 lg:pb-210">
      <!--      <div class="blex-top w-full bg-black h-7/10-screen lg:h-screen">-->

      <div class="blex bg-black w-full mb-40 lg:mb-60">
        <div class="text-white font-bold text-2xl lg:text-6xl blex pt-0 lg:pt-210 bottom-gradient pb-12">
          LISTED
        </div>
      </div>

      <div class="blex w-full lg:w-7/10">
        <a target="_blank"
           href="https://www.mexc.com/exchange/MCT_USDT"
           class="logo">
          <img src="@/assets/images/pages/main/partners/mexc.png" alt="" class="w-full">
        </a>
        <a target="_blank"
           href="https://www.gopax.co.kr/exchange/mct-krw"
           class="logo">
          <img src="@/assets/images/pages/main/partners/gopax.png" alt="" class="w-full">
        </a>
        <a target="_blank"
           href="https://app.rubic.exchange/?fromChain=ETH&toChain=BSC&from=ETH&amount=1&to=0x8038b1f3eb4f70436569618530ac96b439d67bae"
           class="logo">
          <img src="@/assets/images/pages/main/partners/rubic.png" alt="" class="w-full">
        </a>
        <a target="_blank"
           href="https://pancakeswap.finance/swap?inputCurrency=0x8038b1f3eb4f70436569618530ac96b439d67bae"
           class="logo">
          <img src="@/assets/images/pages/main/partners/pancakeswap.png" alt="" class="w-full">
        </a>
        <a target="_blank"
           href="https://microtuber.io/wp-content/uploads/2020/12/CertiK_Audit_Report_for_Micro_Tuber.pdf" class="logo">
          <img src="@/assets/images/pages/main/partners/certik.png" alt="" class="w-full">
        </a>
        <a target="_blank"
           href="https://xangle.io/project/MCT/profile"
           class="logo">
          <img src="@/assets/images/pages/main/partners/xangle.png" alt="" class="w-full">
        </a>
      </div>
    </div>

  </section>

</template>

<script>
export default {
  name: 'Listed'
}
</script>

<style scoped lang="scss">
section::v-deep {
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    margin: 10px;
    width: 150px;
    height: 150px;
    background: #fff;
    transition: all .2s;
    border: 2px solid rgba(0, 0, 0, .4);

    &:hover {
      transform: scale(1.2);
      transition: all .2s;
    }

    @media screen and (max-width: 1024px) {
      width: 100px;
      height: 100px;
      padding: 12px;


    }

  }

  //.image-container {
  //  animation: slide 10s linear infinite;
  //  transform: translate3d(0, 0, 0);
  //}
  //
  //@keyframes slide {
  //
  //  0% {
  //    transform: translate3d(0vw, 0, 0);
  //  }
  //  100% {
  //    transform: translate3d(-99vw, 0, 0);
  //  }
  //}

}

</style>
